import type { Proposta } from '@/types'
import { overlayCatalogScopeOnItem, type CatalogPlan } from '@/utils/planCatalog'
import type { TemplateType } from '@/utils/dealCalculations'

export function applyCatalogToProposal(proposal: Proposta, catalogPlans: CatalogPlan[]): Proposta {
  if (!catalogPlans.length) return proposal
  const rawItems = proposal.itens || proposal.items || []
  const synced = rawItems.map((item) => overlayCatalogScopeOnItem(item, catalogPlans))
  return { ...proposal, itens: synced, items: synced }
}

export function detectTemplateType(value?: string): TemplateType {
  const text = (value || '').toLowerCase()
  if (text.includes('cro')) return 'cro'
  if (
    text.includes('layout personalizado') ||
    text.includes('layout-personalizado') ||
    text.includes('desenvolvimento-layout') ||
    text.includes('e-commerce personalizado') ||
    text.includes('desenvolvimento e-commerce')
  ) {
    return 'layout-personalizado'
  }
  if (text.includes('ecommerce') || text.includes('e-commerce')) return 'ecommerce'
  if (text.includes('site institucional') || text.includes('site-institucional')) {
    return 'site-institucional'
  }
  return 'generico'
}
